// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"627":"44c18bfa","738":"442f00a2","923":"4dea1f83"}[chunkId] + ".chunk.js";
};